import {CustomDataEntry} from "controls/designer/customDataEntry";
import {ApiRequest} from "framework/api";

import {CustomDataListEntry} from "controls/designer/features/widgets/custom-data-list/customDataListEntry";

type GetDataSourcesListArgs = {
	dataSources: CustomDataEntry[]
}

export function getDataSourcesList(args: GetDataSourcesListArgs) {
	const dataSources = args.dataSources.filter(x => x.dataSource || x.widgetConfig);

	return new ApiRequest<CustomDataListEntry[]>({
		url: 'dashboards/customDataInfo',
		payload: dataSources
	});
}
